/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 *
 * @export
 * @interface GridEventState
 */
export interface GridEventState {
  /**
   *
   */
  state: EventStateEnum;
  /**
   *
   */
  stateDetail: any | null;
  /**
   *
   */
  gridId?: number | null;
}

/**
 * Check if a given object implements the GridEventState interface.
 */
export function instanceOfGridEventState(value: object): value is GridEventState {
  if (!("state" in value) || value["state"] === undefined) return false;
  if (
    (!("stateDetail" in (value as Record<string, any>)) &&
      !("state_detail" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["stateDetail"] === undefined &&
      (value as Record<string, any>)["state_detail"] === undefined)
  )
    return false;
  return true;
}

export function GridEventStateFromJSON(json: any): GridEventState {
  return GridEventStateFromJSONTyped(json, false);
}

export function GridEventStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GridEventState {
  if (json == null) {
    return json;
  }
  return {
    state: EventStateEnumFromJSON(json["state"]),
    stateDetail: json["state_detail"],
    gridId:
      json["grid_id"] === undefined ? undefined : json["grid_id"] === null ? null : json["grid_id"],
  };
}

export function GridEventStateToJSON(json: any): GridEventState {
  return GridEventStateToJSONTyped(json, false);
}

export function GridEventStateToJSONTyped(
  value?: GridEventState | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    state: EventStateEnumToJSON(value["state"]),
    state_detail: value["stateDetail"],
    grid_id: value["gridId"],
  };
}
